// extracted by mini-css-extract-plugin
export default {"wrapper":"MaterialElement_wrapper__wv9NF","colorContainer":"MaterialElement_colorContainer__REt9m","colorItem":"MaterialElement_colorItem__JDxD5"};